angular.module('bizmetryApp').controller('LoginController', [
  '$scope', '$http', '$mdDialog', '$location', '$timeout', 'AuthService', 'ConfigurationService', 'dialogService', 'CONFIG',
  function ($scope, $http, $mdDialog, $location, $timeout, AuthService, ConfigurationService, dialogService, CONFIG) {

    $scope.user = {};
    $scope.isModal = false;
    $scope.showPassword = false;
    $scope.isLoggingIn = false;
    $scope.trustOrgs = [];
    $scope.orgsLoading = true;

    // A bounded page keeps the login layout stable for any organization count.
    const ORG_PAGE_SIZE = 4;
    $scope.orgPage = 0;
    $scope.orgPageSize = ORG_PAGE_SIZE;
    $scope.organizationInitials = function (name) {
      const words = String(name || '').trim().split(/\s+/).filter(Boolean);
      return words.length > 1 ? (words[0][0] + words[1][0]).toUpperCase()
        : (words[0] || '').slice(0, 2).toUpperCase();
    };
    $scope.organizationColor = function (name) {
      const colors = ['#6979df', '#8056cd', '#348ebd', '#7060cf'];
      let hash = 0;
      for (const char of String(name || '')) hash = ((hash << 5) - hash + char.charCodeAt(0)) | 0;
      return colors[(hash >>> 0) % colors.length];
    };
    $scope.changeOrgPage = function (direction) {
      const lastPage = Math.max(0, Math.ceil($scope.trustOrgs.length / ORG_PAGE_SIZE) - 1);
      $scope.orgPage = Math.max(0, Math.min(lastPage, $scope.orgPage + direction));
    };
    $scope.orgPageEnd = function () {
      return Math.min(($scope.orgPage + 1) * ORG_PAGE_SIZE, $scope.trustOrgs.length);
    };

    // ── Load orgs ──
    function loadOrganizations() {
      $scope.orgsLoading = true;
      AuthService.loadOrganizations()
        .then(function (orgs) {
          $scope.trustOrgs = orgs;
          $scope.orgsLoading = false;
          $scope.orgPage = 0;
        })
        .catch(function (err) {
          console.warn('📍 Could not load org list:', err);
          $scope.orgsLoading = false;
          $scope.trustOrgs = [];
        });
    }

    loadOrganizations();

    // =====================================================
    // SUCCESS DIALOG
    // =====================================================
    function showSuccessDialog(callback) {
      const user = JSON.parse(sessionStorage.getItem('user') || '{}');
      const firstName = user.firstName || user.first_name || user.username || '';

      $mdDialog.show({
        templateUrl: '/login/login-success-dialog.html',
        onShowing: function (scope, element) {
          element.parent().addClass('login-feedback-container');
        },
        controller: function ($scope) { $scope.username = firstName; },
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        escapeToClose: false,
        hasBackdrop: true,
        disableParentScroll: false,
        onComplete: function () {
          $timeout(function () {
            $mdDialog.hide();
            if (callback) callback();
          }, 2200);
        }
      });
    }

    // =====================================================
    // ERROR DIALOG
    // =====================================================
    function showLoginErrorDialog(title, message) {
      $mdDialog.show({
        templateUrl: '/login/login-error-dialog.html',
        onShowing: function (scope, element) {
          element.parent().addClass('login-feedback-container');
        },
        controller: function ($scope, $mdDialog) {
          $scope.title = title;
          $scope.message = message;
          $scope.close = function () { $mdDialog.hide(); };
        },
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        escapeToClose: true,
        hasBackdrop: true,
        disableParentScroll: false
      });
    }

    // =====================================================
    // 2FA DIALOG
    // =====================================================
    function show2FADialog() {
      $mdDialog.show({
        template: `
      <md-dialog>
        <two-fa-validator
            email="{{ $ctrl.email }}"
            on-success="$ctrl.onSuccess(code)"
            on-cancel="$ctrl.onCancel()">
        </two-fa-validator>
      </md-dialog>
    `,
        controller: function ($mdDialog) {
          this.email = $scope.user.username;
          this.onSuccess = function (code) { $mdDialog.hide({ code: code }); };
          this.onCancel = function () { $mdDialog.cancel(); };
        },
        controllerAs: '$ctrl',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        escapeToClose: false,
        hasBackdrop: true
      })
        .then(function (result) {
          if (result && result.code) {
            console.log('🔐 2FA validated — re-invoking login with code');
            $scope.login(result.code);
          }
        })
        .catch(function () {
          console.log('🔐 2FA cancelled by user');
          $scope.isLoggingIn = false;
        });
    }
    // =====================================================
    // LOGIN
    // =====================================================
    $scope.login = function (twoFaCode) {
      $scope.isLoggingIn = true;

      AuthService.authenticate($scope.user.username, $scope.user.password, twoFaCode)
        .then(function (response) {
          if (response.access_token) {
            const user = JSON.parse(sessionStorage.getItem('user'));
            console.log('✅ User stored in sessionStorage:', user);

            ConfigurationService.loadAllConfig().then(() => {
              console.log('✅ Configuración cargada tras login');
            });

            showSuccessDialog(function () {
              $timeout(function () { $location.path('/home'); });
            });

          } else {
            $scope.isLoggingIn = false;
            showLoginErrorDialog('Login Error', 'Invalid credentials.');
          }
        })
        .catch(function (error) {
          $scope.isLoggingIn = false;
          console.error('🚨 Login API Error:', error);

          // ── 2FA required ──────────────────────────────────
          if (error.data && error.data.error_code === '2FA_REQUIRED') {
            show2FADialog();
            return;
          }

          // ── Resto de errores ──────────────────────────────
          const backendMessage = error?.data?.message || error?.data?.error || null;
          const statusCode = error?.status || null;

          let title = 'Unexpected Error';
          let message = 'An unexpected error has occurred.';

          if (backendMessage) {
            const lower = backendMessage.toLowerCase();
            if (lower.includes('inactive')) { title = 'Inactive Account'; message = backendMessage; }
            else if (lower.includes('not registered')) { title = 'User Not Found'; message = backendMessage; }
            else if (lower.includes('invalid username') || lower.includes('invalid credentials')) { title = 'Login Failed'; message = backendMessage; }
            else if (statusCode === 403) { title = 'Access Denied'; message = backendMessage; }
            else if (statusCode === 404) { title = 'Not Found'; message = backendMessage; }
            else if (statusCode === 401) { title = 'Authentication Failed'; message = backendMessage; }
            else { title = 'Login Error'; message = backendMessage; }
          } else if (statusCode) {
            const map = {
              401: ['Authentication Failed', 'Invalid username or password.'],
              403: ['Access Denied', 'You do not have permission to access this resource.'],
              404: ['User Not Found', 'The specified user account does not exist.'],
              500: ['Server Error', 'An internal server error occurred. Please try again later.'],
              503: ['Service Unavailable', 'The service is temporarily unavailable. Please try again later.']
            };
            [title, message] = map[statusCode] || ['Connection Error', `An error occurred (Status: ${statusCode}). Please try again.`];
          }

          showLoginErrorDialog(title, message);
        });
    };

    $scope.goToRegister = function () { $location.path('/register'); };

    // =====================================================
    // ACCOUNT RECOVERY DIALOG
    // =====================================================
    // =====================================================
    // ACCOUNT RECOVERY DIALOG  — in LoginController
    // =====================================================
    $scope.lostPassword = function () {
      $mdDialog.show({
        templateUrl: '/login/account-recovery/login-recover-dialog.html',
        controller: 'LoginRecoverDialogController',   // named controller
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        escapeToClose: true,
        multiple:true,
        hasBackdrop: true,
        disableParentScroll: false
      });
    };
  }
]);